import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Drawer, Popconfirm,
} from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import PaymentTermActions from '@Actions/configurations/paymentTermActions';
import UserActions from '@Actions/userActions';
import PaymentTermForm from './PaymentTermForm';
import './style.scss';

/**
 *
 */
const PaymentTerm = ({
  user, org, getOrg, getOrgLoading, updatePaymentTerm, updatePaymentTermLoading,
}) => {
  const [showNewPaymentTermModal, setShowNewPaymentTermModal] = useState(false);

  const [showUpdatePaymentTermModal, setShowUpdatePaymentTermModal] = useState(false);

  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState([]);

  // useEffect(() => {
  //   getPaymentTerms(user?.tenant_info?.org_id);
  // }, []);

  const paymentTerms = org?.organisation?.[0]?.default_payment_terms?.map((item, index) => ({ ...item, index }));

  const deletePaymentTerm = (index) => {
    const copyAllPaymentTerms = paymentTerms?.filter((item) => item?.index !== index)?.map((item) => ({
      due_days: item?.due_days,
      remark: item?.remark,
    }));
    const payload = {
      org_id: user?.tenant_info?.org_id,
      payment_terms: copyAllPaymentTerms,
    };
    updatePaymentTerm(payload,
      () => getOrg(user?.tenant_info?.org_id));
  };

  // eslint-disable-next-line eqeqeq
  const selectedDays = () => paymentTerms?.filter((item) => item.due_days != selectedPaymentTerm.due_days).map((item) => item.due_days) || [];

  const paymentTermListColumns = [
    {
      title: 'NUMBER OF DAYS',
      render: (text, record) => (
        <Fragment>
          {/* eslint-disable-next-line eqeqeq */}
          {record?.due_days == 0 ? 'Due on Delivery' : `${record?.due_days} Days`}
        </Fragment>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <div style={{
          textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
        }}
        >
          <div
            className="roundIconButton"
            onClick={() => {
              setShowUpdatePaymentTermModal(true);
              setSelectedPaymentTerm(record);
            }}
          >
            <EditOutlined />
          </div>
          <Popconfirm
            placement="topRight"
            title="Are you sure you want to delete this payment term?"
            onConfirm={() => deletePaymentTerm(record?.index)}
            okText="Yes"
            cancelText="No"
          >
            <div
              className="deleteButton"
            >
              <DeleteOutlined />
            </div>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <div className="payment-term__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-18">
            <div className="payment-term__table__wrapper">
              <div className="payment-term__table__data hide__in-mobile">
                <Table
                  title={() => (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      {`${org?.organisation?.[0]?.default_payment_terms?.length || '0'} ${'Payment Term(s)'}`}
                      <Fragment>
                        {Helpers.getPermission(Helpers.permissionEntities.VENDORS,
                          Helpers.permissionTypes.CREATE, user) && (
                          <H3Button
                            buttonType={defaultButtonTypes.BLUE_ROUNDED}
                            text="+ New Payment Term"
                            onClick={() => setShowNewPaymentTermModal(true)}
                            customClass="payment-term__header__add-button hide__in-mobile"
                          />
                        )}
                      </Fragment>
                    </div>
                  )}
                  loading={getOrgLoading || updatePaymentTermLoading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={paymentTermListColumns}
                  dataSource={paymentTerms || []}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showNewPaymentTermModal}
        width="360px"
        mask
        onClose={() => setShowNewPaymentTermModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Add New Payment Term" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewPaymentTermModal(false)} />
          </div>
        </div>
        <div className="create-po__new-vendor-wrapper">
          <PaymentTermForm
            callback={() => {
              getOrg(user?.tenant_info?.org_id);
              setShowNewPaymentTermModal(false);
            }}
            paymentTerms={paymentTerms}
            selectedDays={() => selectedDays()}
          />
        </div>
      </Drawer>
      <Drawer
        title="Update Payment Term"
        open={showUpdatePaymentTermModal}
        onClose={() => setShowUpdatePaymentTermModal(false)}
        width="360px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Update Payment Term" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdatePaymentTermModal(false)} />
          </div>
        </div>
        <PaymentTermForm
          selectedPaymentTerm={selectedPaymentTerm}
          paymentTerms={paymentTerms}
          callback={() => {
            getOrg(user?.tenant_info?.org_id);
            setShowUpdatePaymentTermModal(false);
          }}
          selectedDays={() => selectedDays()}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, PaymentTermsReducers }) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  getOrgLoading: UserReducers.getOrgLoading,
  updatePaymentTermLoading: PaymentTermsReducers.updatePaymentTermLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getPaymentTerms: (orgId, page, limit, searchKeyword) => dispatch(PaymentTermActions.getPaymentTerms(orgId, page, limit, searchKeyword)),
  getOrg: (orgId) => dispatch(UserActions.getOrg(orgId)),
  updatePaymentTerm: (payload, callback) => dispatch(PaymentTermActions.updatePaymentTerm(payload, callback)),
});

PaymentTerm.propTypes = {
  user: PropTypes.any,
  org: PropTypes.any,
  getOrg: PropTypes.func,
  getOrgLoading: PropTypes.bool,
  updatePaymentTermLoading: PropTypes.bool,
  updatePaymentTerm: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PaymentTerm));
